import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import * as _ from 'lodash';

import { ISlimScrollOptions } from 'ng2-slimscroll';
import { MemberService } from '../member.service';
import { MessageEvent, HandleSideMenuWithAuth, SignInEvent, OpenFrameEvent, LoaderEvent, SidemenuSubCategory, HiddenFooter, SetAllMemberCheck } from '../../shared/message.event';
import { AppService } from '../../app.service';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { UtilityFunctions } from '../../shared/utility-functions';
import { BlockSlots } from '../../shared/blockSlots';
import { BaseMember } from '../base-member';

@Component({
  selector: 'staff-list',
  templateUrl: './staff-list.component.html',
  styleUrls: ['./staff-list.component.css'],
  providers: [
    MemberService,
    MessageEvent,
    SignInEvent,
    OpenFrameEvent,
    LoaderEvent,
    SidemenuSubCategory,
    HiddenFooter,
    SetAllMemberCheck,
    HandleSideMenuWithAuth
  ]
})
export class StaffListComponent extends BaseMember implements OnInit {
  // ===== Public fields used by template =====
  public stringConstants = CONSTANT_MESSAGES;
  public shouldSlide: boolean = false;

  public noMemberAvailableInFilter: boolean = false;
  public noMemberAvailable: boolean = true;

  public exp: boolean = false;
  public searchMember: string = '';
  public isopen: boolean = false;

  public selectItem: boolean = false;
  public filterSendInvite: boolean = false;
  public showFilterPreference: boolean = false;
  public showFilterFacility: boolean = false;
  public showFilterGroup: boolean = false;

  public openSubMenu1: boolean = false;
  public openSubMenu2: boolean = false;
  public openSubMenu3: boolean = false;
  public openSubMenu4: boolean = false;

  public allFilter: boolean = false;

  // filter lists
  public facilityList: any[] = [];
  public preferenceList: any[] = [];
  public groupList: any[] = [];
  public filterStateSubMenuList: any[] = [];
  public inviteStatusFilter: boolean[] = [];

  // table & pagination
  public memberList: any[] = [];
  public totalSizeOfList: number = 0;
  public onePagePerItem: number = 10;
  public pageOptions: any = {
    currentPage: 1,
    noOfPageItem: this.onePagePerItem
  };
  public numberOfPage: number = 0;

  // misc
  public message: string = '';
  public popupTitle: string = '';
  public popUpMessage: string = '';
  public clubName: string = '';
  public filterPara: string = '';
  public filterState: any = '';
  public height: any;
  public scrollOptions: ISlimScrollOptions;

  @ViewChild('fileUploadInput') public fileUploadInputVariable: any;
  @ViewChild('bookingFileUploadInput') public fileBookingUploadInputVariable: any;
  @ViewChild('searchInput') public searchInputVariable: any;
  @ViewChild('memberTable') public tableVariable: any;

  // upload/invite support
  public member: any = { vendorId: '', members: [] };
  public successfullyAddedMembers: any[] = [];
  public failedLogObj: any[] = [];
  public sentInvitesList: any[] = [];
  public sendInviteFlag: boolean = false;
  public setChecked: any[] = [];
  public sendInviteFliterList = [{ name: 'Sent', status: true }, { name: 'Not Sent', status: false }];
  public sendMailToAddedMembersList: any[] = [];
  public addedMembers: any = {
    vendorId: '',
    members: [],
    clubName: '',
    isWaitForCallback: true
  };

  // ===== Private fields (not bound in template) =====
  private hideEdit: boolean;
  private windowHeight = window.innerHeight;
  private topNav = 56;
  private midNav = 45;
  private footer = 35;
  private container = 20;
  private divHeight = 30;
  private expInternal: boolean = false; // unused externally
  private blockSlots = new BlockSlots();

  constructor(
    private router: Router,
    private memberService: MemberService,
    private appService: AppService,
    private openFrameEvent: OpenFrameEvent,
    private messageEvent: MessageEvent,
    private signInEvent: SignInEvent,
    private loaderEvent: LoaderEvent,
    private sidemenuSubCategory: SidemenuSubCategory,
    private hiddenFooter: HiddenFooter,
    private handleSideMenuWithAuth: HandleSideMenuWithAuth,
    private setAllMemberCheck: SetAllMemberCheck
  ) {
    super();
    this.popUpMessage = 'Is Payment Done';
    this.hideEdit = false;
    this.scrollOptions = {
      barBackground: "#343a40", barOpacity: "0.6", position: "right",
      barWidth: "6", barBorderRadius: "5", barMargin: "1px 1px",
      gridBackground: "#adb5bd", gridOpacity: "1", gridWidth: "4",
      gridBorderRadius: "10", gridMargin: "1px 2px"
    };
    this.height = (this.windowHeight - (this.topNav + this.midNav + this.container + this.footer + this.divHeight)) + 'px';
    this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
    this.noMemberAvailable = true;
  }

  ngOnInit() {
    const obj = { category: 'All Members', menu: 'Members' };
    this.sidemenuSubCategory.fire(obj);

    if (this.vendor.role == CONSTANT_VALUES.SUPER_ADMIN) {
      if (this.vendor.subVendors.length > 0) {
        const subVendor = this.vendor.subVendors[0];
        this.clubName = subVendor.clubName;
      }
    } else {
      this.clubName = this.vendor.clubName;
    }

    // side-menu needs
    if (this.vendor.role == CONSTANT_VALUES.ROLE_VENDOR_ADMIN) {
      this.appService.getFacilityByClub(this.vendor._id);
    } else if (this.vendor.role == CONSTANT_VALUES.SUPER_ADMIN) {
      if (this.vendor.subVendors.length > 0) {
        const subVendor = this.vendor.subVendors[0];
        this.appService.getFacilityByClub(subVendor._id);
      }
    } else {
      this.appService.getFacilityByClub(this.vendor.vendorId);
    }

    this.getFacilityListForMemberFilter(this);
    this.getGroupListForFilter(this);

    // initial load (STAFF table)
    this.pagination(this.pageOptions, 1);

    this.emitOpenFrameEvent();
    this.emitTypeBroadcast();
    this.registerTypeBroadcast();
    this.makeAddedMemberListClear();
  }

  // ===== Staff list (only) =====
  public getStaffListByVendor(vendorObj?: any) {
    if (this.loaderEvent && this.loaderEvent.fire) this.loaderEvent.fire(false);
    const that = this;

    if (!vendorObj) {
      vendorObj = {
        vendorId: (this.vendor && this.vendor._id) ? this.vendor._id : undefined,
        filters: []
      };
    }
    if (!vendorObj.filters) vendorObj.filters = [];

   (vendorObj as any).pageNumber = (this.pageOptions && this.pageOptions.currentPage) ? this.pageOptions.currentPage : 1;
(vendorObj as any).perPage    = (this.pageOptions && this.pageOptions.noOfPageItem) ? this.pageOptions.noOfPageItem : 10;

    return this.appService.getListOfStaff(vendorObj).then(function (result: any) {
      const ok = (result && result.status) ? (result.status === 'SUCCESS') : true;
      if (!ok) {
        that.memberList = [];
        that.totalSizeOfList = 0;
        that.noMemberAvailable = false;
        that.noMemberAvailableInFilter = false;
        if (that.loaderEvent && that.loaderEvent.fire) that.loaderEvent.fire(true);
        that.sendInviteFlag = false;
        return that.memberList;
      }

      let rawStaff: any[] = [];
      if (result && result.vendorData) rawStaff = result.vendorData;
      else if (result && result.staffList) rawStaff = result.staffList;
      else if (result && result.data) rawStaff = result.data;

      let total = 0;
      if (result && result.pagination && typeof result.pagination.total === 'number') total = result.pagination.total;
      else if (typeof result.total === 'number') total = result.total;
      else if (rawStaff && rawStaff.length >= 0) total = rawStaff.length;

      const mapped: any[] = [];
      if (rawStaff && rawStaff.length) {
        for (let i = 0; i < rawStaff.length; i++) {
          const s = rawStaff[i];
          const mem: any = {};
          for (const k in s) if (s.hasOwnProperty(k)) mem[k] = s[k];

          mem.showDetails = true;

          mem.groupActivity = [];
          if (mem.activities && mem.activities.length) {
            for (let j = 0; j < mem.activities.length; j++) {
              const act = mem.activities[j];
              if (act && act.activityName) mem.groupActivity.push(act.activityName);
            }
          }

          mem.type = mem.role;
          mem.sendInviteFlag = !!mem.isInviteSent;
          mem.enable = mem.isBlackListed ? 'Inactive' : 'Active';
          mem.isChecked = false;

          if (mem.signedUpOn && that.utilityFunctions && that.utilityFunctions.maketimeZoneOfsetDate) {
            mem.signedUpOn = that.utilityFunctions.maketimeZoneOfsetDate(mem.signedUpOn).format('DD/MM/YYYY');
          }
          if (mem.hasLeftService && mem.leftServiceDate && that.utilityFunctions && that.utilityFunctions.maketimeZoneOfsetDate) {
            mem.leftServiceDate = that.utilityFunctions.maketimeZoneOfsetDate(mem.leftServiceDate).format('DD/MM/YYYY');
          }

          mapped.push(mem);
        }
      }

      console.log('mapped staff:', mapped);
      that.memberList = mapped;
      that.totalSizeOfList = total;

      // total pages
      if (that.pageOptions && that.pageOptions.noOfPageItem) {
        const perPage = that.pageOptions.noOfPageItem || 10;
        that.numberOfPage = Math.ceil((that.totalSizeOfList || 0) / perPage);
      }

      if (!that.memberList || that.memberList.length === 0) {
        that.noMemberAvailable = false;
      } else {
        that.noMemberAvailable = true;
        if (that.setCheckedList) that.setCheckedList();
      }

      let hasFilter = false;
      if (vendorObj && vendorObj.filters) {
        if (Array.isArray(vendorObj.filters)) hasFilter = vendorObj.filters.length > 0;
        else hasFilter = Object.keys(vendorObj.filters).length > 0;
      }
      that.noMemberAvailableInFilter = !!hasFilter;

      if (that.setAllMemberCheck && that.setAllMemberCheck.fire) that.setAllMemberCheck.fire(true);
      if (that.loaderEvent && that.loaderEvent.fire) that.loaderEvent.fire(true);

      that.sendInviteFlag = false;
      return that.memberList;

    }).catch((err: any) => {
      this.popUpMessage = err;
      if (this.loaderEvent && this.loaderEvent.fire) this.loaderEvent.fire(true);
      return err;
    });
  }

  // ===== Pagination/filter builder (calls only staff) =====
  public pagination(pageOptions: any, pageNo?: number) {
    this.filterState = this.filterPara;
    if (pageOptions) this.pageOptions = pageOptions;

    const vendorObject = this.setVendorIdAsPerRole(this, pageNo);
    this.message = CONSTANT_MESSAGES.NO_MEMBER_ADDED_MESSAGE;
    this.tableVariable.currentPage = pageNo ? pageNo : this.pageOptions.currentPage;

    switch (this.filterPara) {
      case 'Inactive':
        vendorObject['filters'].push({ type: 'isDeactivated', values: true });
        this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
        break;
      case 'DisabledFacility':
        vendorObject['filters'].push({ type: 'disabled', values: this.facilityFilter, applyAll: false });
        this.filterStateSubMenuList = JSON.parse(JSON.stringify(this.facilityFilter));
        this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
        break;
      case 'Prefernces':
        vendorObject['filters'].push({ type: 'facilityPreference', values: this.preferenceFilter, applyAll: false });
        this.filterStateSubMenuList = JSON.parse(JSON.stringify(this.preferenceFilter));
        this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
        break;
      case 'Groups':
        vendorObject['filters'].push({ type: 'group', values: this.groupFilter, applyAll: false });
        this.filterStateSubMenuList = JSON.parse(JSON.stringify(this.groupFilter));
        this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
        break;
      case 'SentInvite':
        if (this.inviteStatusFilter.indexOf(true) >= 0 && this.inviteStatusFilter.indexOf(false) < 0) {
          vendorObject['filters'].push({ type: 'isInviteSent', values: true });
        }
        if (this.inviteStatusFilter.indexOf(false) >= 0 && this.inviteStatusFilter.indexOf(true) < 0) {
          vendorObject['filters'].push({ type: 'isInviteSent', values: false });
        }
        if (this.inviteStatusFilter.length == 0) {
          vendorObject['filters'] = [];
        }
        this.filterStateSubMenuList = JSON.parse(JSON.stringify(this.inviteStatusFilter));
        this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
        break;
    }

    if ((this.searchMember + '').trim()) {
      vendorObject['filters'].push({ type: 'search', values: this.searchMember });
      this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
    }

   (vendorObject as any).pageNumber = pageNo ? pageNo : this.pageOptions.currentPage;
(vendorObject as any).perPage   = this.pageOptions.noOfPageItem;


    this.getStaffListByVendor(vendorObject);
  }

  // ===== UI plumbing =====
  public emitTypeBroadcast() {
    const isShow = { privacypolicy: true, support: false, footer: 'block' };
    this.signInEvent.fire('block');
    this.hiddenFooter.fire(isShow);
  }

  public emitOpenFrameEvent() { this.openFrameEvent.fire(false); }

  public registerTypeBroadcast() {
    this.messageEvent.on().subscribe(message => { this.shouldSlide = message; });
  }

  // ===== Export CSV (kept as-is: exports members + staff) =====
  public convertArrayOfObjectsToCSV(args: any) {
    let result, ctr, keys, columnDelimiter, lineDelimiter, data;
    data = args.data || null;
    if (data == null || !data.length) return null;

    columnDelimiter = args.columnDelimiter || ',';
    lineDelimiter = args.lineDelimiter || '\n';
    keys = Object.keys(data[0]);
    result = '';
    result += keys.join(columnDelimiter);
    result += lineDelimiter;

    data.forEach(function (item: any) {
      ctr = 0;
      keys.forEach(function (key: string) {
        if (ctr > 0) result += columnDelimiter;
        result += (item[key] !== undefined && item[key] !== null) ? item[key] : '';
        ctr++;
      });
      result += lineDelimiter;
    });
    return result;
  }

  public exportMembers() {
    const vendorObj = { vendorId: this.vendor._id };
    const exportList: any[] = [];
    this.appService.getListOfMember(vendorObj).then((result: any) => {
      if (result && result.memberList) {
        result.memberList.forEach((member: any) => exportList.push(member));
      }
      return exportList;
    }).then((list) => {
      return this.appService.getListOfStaff(vendorObj).then((result: any) => {
        if (result && result.vendorData) {
          result.vendorData.forEach((staff: any) => list.push(staff));
        }
        return list;
      });
    }).then((list) => {
      let data, filename, link;
      const objectToConvert = list.map((member: any) => {
        const type = member.type ? member.type : 'NA';
        const group = member.groups ? member.groups : [];
        const types = (type + '').split(',').map((t: string) => t);

        return {
          "Membership Id": member.membershipId ? member.membershipId : 'NA',
          "First Name": member.firstName || 'NA',
          "Last Name": member.lastName || 'NA',
          "Email Id": member.emailId || 'NA',
          "Country Code": member.countryCode || 'NA',
          "Contact Number": member.contactNumber || 'NA',
          "Address Line 1": member.addressLine1 ? member.addressLine1 : 'NA',
          "Address Line 2": member.addressLine2 ? member.addressLine2 : 'NA',
          "Notes": member.note ? member.note : 'NA',
          "Type 1": types[0] ? types[0] : 'NA',
          "Type 2": types[1] ? types[1] : 'NA',
          "Type 3": types[2] ? types[2] : 'NA',
          "Type 4": types[3] ? types[3] : 'NA',
          "Type 5": types[4] ? types[4] : 'NA',
          "Group 1": group[0] ? group[0] : 'NA',
          "Group 2": group[1] ? group[1] : 'NA',
          "Group 3": group[2] ? group[2] : 'NA',
          "Group 4": group[3] ? group[3] : 'NA',
          "Group 5": group[4] ? group[4] : 'NA',
        };
      });

      const csv = this.convertArrayOfObjectsToCSV({ data: objectToConvert });
      if (csv == null) return;
      filename = 'members.csv';
      const payload = csv.match(/^data:text\/csv/i) ? csv : ('data:text/csv;charset=utf-8,' + csv);
      data = encodeURI(payload);
      link = document.createElement('a');
      link.setAttribute('href', data);
      link.setAttribute('download', filename);
      link.click();
    });
  }

  // ===== Misc UI actions =====
  public onNotify() { this.router.navigate(['/']); }

  public resetFileUploadInput() { if (this.fileUploadInputVariable) this.fileUploadInputVariable.nativeElement.value = ''; }
  public resetFileBookingUploadInput() { if (this.fileBookingUploadInputVariable) this.fileBookingUploadInputVariable.nativeElement.value = ''; }

  public expand() {
    if ((this.searchMember + '').trim()) {
      this.pagination(this.pageOptions, 1);
    } else {
      this.searchMember = '';
      if (this.exp) this.pagination(this.pageOptions, 1);
      this.exp = !this.exp;
    }
  }

  public redirectToAddMember() {
    if (localStorage.getItem('vendor')) { this.router.navigate(['/addmember']); }
  }

  public redirectToCreateGroup() {
    if (localStorage.getItem('vendor')) { this.router.navigate(['/creategroup']); }
  }

  public getVendorDetails() {
    try {
      const obj = { vendorId: this.vendor._id };
      this.memberService.getVendorDetails(obj).then((result: any) => {
        if (result.status === 'SUCCESS' && result.vendor && result.vendor.length) {
          this.vendor = result.vendor[0];
        }
      });
    } catch (err) { }
  }

  // ===== Invite selection helpers =====
  public sendMailToAddedMembers(popupObj: any, showLog: any) {
    this.loaderEvent.fire(false);
    const that = this;
    this.sentInvitesList = [];
    that.addedMembers.vendorId = this.vendor._id;
    that.addedMembers.clubName = this.vendor.clubName;
    that.addedMembers.members = [];

    if (that.sendMailToAddedMembersList && that.sendMailToAddedMembersList.length > 0) {
      that.sendMailToAddedMembersList.forEach(function (rec: any) {
        that.addedMembers.members.push(rec['obj']);
      });
      that.addedMembers.isWaitForCallback = true;
      this.memberService.sendMailToMembers(that.addedMembers).then((result: any) => {
        if (result.status === 'SUCCESS') {
          this.makeAddedMemberListClear();
          this.setSendInviteFlag();
          if (result.members && result.members.length > 0) {
            that.sentInvitesList = _.cloneDeep(result.members);
            this.pagination(this.pageOptions, 1);
            that.successfullyAddedMembers = [];
            that.sendMailToAddedMembersList = [];
            showLog.showChildModal(2, [], [], that.sentInvitesList, [], []);
          }
        } else {
          this.loaderEvent.fire(true);
          that.popUpMessage = result['message'];
          popupObj.showChildModal();
        }
        this.sendInviteFlag = true;
      });
    } else {
      this.loaderEvent.fire(true);
      that.popUpMessage = 'Please select member';
      popupObj.showChildModal();
    }
  }

  public uploadCsv(event: any, popupObj: any, showLog: any) {
    if (event.flag) this.uploadBookingFile(event, popupObj, showLog);
    else this.uploadFile(event, popupObj, showLog);
  }

  public uploadFile(event: any, popUpObj: any, showLog: any) {
    this.loaderEvent.fire(false);
    const input = event.target;
    const file = input.files[0];
    const that = this;
    that.sendMailToAddedMembersList = [];
    this.successfullyAddedMembers = [];
    if (file.name.indexOf('.csv') !== -1) {
      this.memberService.getMembersFromFile(input).then((result1: any) => {
        that.member.members = result1.members;
        that.failedLogObj = result1['logList'];
        if ((!result1.members || (result1.members && result1.members.length <= 0)) && (!result1['logList'] || (result1['logList'] && result1['logList'].length <= 0))) {
          this.popUpMessage = 'There is no record to add member';
          this.loaderEvent.fire(true);
          popUpObj.showChildModal();
          return;
        }
        if (this.member.members && this.member.members.length > 0) {
          this.member.vendorId = this.vendor._id;
          this.memberService.uploadMember(this.member).then((result: any) => {
            if (result.status === 'SUCCESS') {
              if (result.notAdded && result.notAdded.length > 0) {
                result.notAdded.filter(function (rec: any) {
                  that.failedLogObj.push({ obj: rec, logList: rec['reason'] });
                });
              }
              if (result.added && result.added.length > 0) {
                result.added.filter(function (rec: any) {
                  that.successfullyAddedMembers.push({ obj: rec, logList: CONSTANT_MESSAGES.REMARK_MEMBER });
                });
                result.added.filter(function (rec: any) {
                  that.sendMailToAddedMembersList.push({ obj: rec, logList: CONSTANT_MESSAGES.REMARK_MEMBER });
                });
              }
              if (result.updated && result.updated.length > 0) {
                result.updated.filter(function (rec: any) {
                  that.successfullyAddedMembers.push({ obj: rec, logList: 'member updated Successfully' });
                });
              }
              if (result.typeUpdated && result.typeUpdated.length > 0) {
                result.typeUpdated.filter(function (rec: any) {
                  that.successfullyAddedMembers.push({ obj: rec, logList: 'member type updated Successfully' });
                });
              }
              if (result.groupAdded && result.groupAdded.length > 0) {
                result.groupAdded.filter(function (rec: any) {
                  that.successfullyAddedMembers.push({ obj: rec, logList: 'Member is added in group Successfully' });
                });
              }
              that.pagination(that.pageOptions, 1);
              that.loaderEvent.fire(true);
              showLog.showChildModal(1, that.failedLogObj, that.successfullyAddedMembers, [], [], []);
            } else {
              that.loaderEvent.fire(true);
              that.popUpMessage = result['message'];
              popUpObj.showChildModal();
            }
          });
        } else {
          that.loaderEvent.fire(true);
          showLog.showChildModal(1, that.failedLogObj, that.successfullyAddedMembers, [], [], []);
        }
      });
    } else {
      this.loaderEvent.fire(true);
      this.popUpMessage = CONSTANT_MESSAGES.FILE_NOT_SUPPORT;
      popUpObj.showChildModal();
    }
  }

  public uploadBookingFile(event: any, popupObj: any, showLog: any) {
    const input = event.target;
    const file = input.files[0];
    const that = this;
    let bookingLogList: any[] = [];
    let confirmBookingList: any[] = [];
    let bookingList: any[] = [];
    if (file.name.indexOf('.csv') !== -1) {
      this.memberService.getBookingsFromFile(input).then((result: any) => {
        if (result['message'] === CONSTANT_MESSAGES.INVALID_FILE_COLUMNS) {
          this.popUpMessage = CONSTANT_MESSAGES.INVALID_FILE_COLUMNS;
          popupObj.showChildModal();
        } else if ((!result['loglList'] || (result['loglList'] && result['loglList'].length <= 0)) && (!result['booking'] || (result['booking'] && result['booking'].length <= 0))) {
          this.popUpMessage = 'There are no records to do bookings';
          popupObj.showChildModal();
          return;
        } else {
          bookingLogList = result['loglList'];
          bookingList = result['booking'];
          if (bookingList && bookingList.length > 0) {
            const requestObj = { 'vendorId': this.vendor._id, 'bookings': bookingList }
            this.loaderEvent.fire(true);
            this.memberService.uploadBookings(requestObj).then((result2: any) => {
              if (result2.status === 'SUCCESS') {
                this.makeAddedMemberListClear();
                if (result2.notAdded && result2.notAdded.length > 0) {
                  result2.notAdded.filter(function (rec: any) {
                    bookingLogList.push({ obj: rec, logList: rec['reason'] });
                  });
                }
                if (result2.added && result2.added.length > 0) {
                  result2.added.filter(function (rec: any) {
                    confirmBookingList.push({ obj: rec, logList: rec['reason'] });
                  });
                }
                this.loaderEvent.fire(true);
                showLog.showChildModal(3, [], [], [], confirmBookingList, bookingLogList);
              } else {
                that.loaderEvent.fire(true);
                that.popUpMessage = result2['message'];
                popupObj.showChildModal();
              }
            });
          } else {
            showLog.showChildModal(3, [], [], [], confirmBookingList, bookingLogList);
          }
        }
      });
    } else {
      this.popUpMessage = CONSTANT_MESSAGES.FILE_NOT_SUPPORT;
      popupObj.showChildModal();
    }
  }

  public addMemberInInviteList(memberObj: any) {
    if (memberObj.isChecked) {
      this.successfullyAddedMembers.push({ obj: memberObj, logList: CONSTANT_MESSAGES.REMARK_MEMBER });
      this.setChecked.push(memberObj.userId);
    } else {
      _.remove(this.successfullyAddedMembers, function (n: any) { return n.obj.userId === memberObj.userId; });
      _.remove(this.setChecked, function (n: any) { return n === memberObj.userId; });
      _.remove(this.sendMailToAddedMembersList, function (n: any) { return n.obj.userId === memberObj.userId; });
      if (this.tableVariable && this.tableVariable.allInGroup) { this.tableVariable.allInGroup = false; }
    }
    if (this.successfullyAddedMembers.length === 0) {
      if (this.tableVariable) this.tableVariable.allInGroup = false;
    } else {
      this.successfullyAddedMembers = _.uniqBy(this.successfullyAddedMembers, function (e: any) { return e.obj.contactNumber; });
      this.successfullyAddedMembers.forEach(member => { this.sendMailToAddedMembersList.push(member) });
    }
    this.setSendInviteFlag();
  }

  public makeAllMemberForInvite(memberList: any) {
    this.setChecked = this.setChecked.concat(memberList);
    if (!this.tableVariable.allInGroup) {
      this.setChecked = _.difference(this.setChecked, memberList);
      this.removeMembersFromSuccessfullyAddedMembers(memberList);
    } else {
      this.setUserListToSendInvite();
    }
    this.setSendInviteFlag();
  }

  public removeMembersFromSuccessfullyAddedMembers(memberList: any[]) {
    this.successfullyAddedMembers = this.successfullyAddedMembers.filter(function (rec: any) {
      if (memberList.indexOf(rec.obj.userId) >= 0) { return false; }
      return true;
    });
  }

  public setUserListToSendInvite() {
    let i = 0;
    while (i <= this.memberList.length - 1) {
      if (this.setChecked.indexOf(this.memberList[i].userId) >= 0 && !this.memberList[i].sendInviteFlag) {
        this.successfullyAddedMembers.push({ obj: this.memberList[i], logList: CONSTANT_MESSAGES.REMARK_MEMBER });
      }
      i++;
    }
    this.successfullyAddedMembers = _.uniqBy(this.successfullyAddedMembers, function (e: any) { return e.obj.contactNumber; });
    this.successfullyAddedMembers.forEach(member => { this.sendMailToAddedMembersList.push(member) });
  }

  public setCheckedList() {
    let flagAllChecked = true;
    for (let rec of this.setChecked) {
      for (let mem of this.memberList) {
        if (rec === mem.userId) { mem.isChecked = true; break; }
      }
    }
    for (let mem of this.memberList) {
      if (!mem.isChecked) { flagAllChecked = false; break; }
    }
    if (flagAllChecked) this.tableVariable.allInGroup = true;
    else this.tableVariable.allInGroup = false;
  }

  public makeAddedMemberListClear() {
    this.successfullyAddedMembers = [];
    this.memberList.map(function (member: any) { member.isChecked = false; });
    if (this.tableVariable) this.tableVariable.allInGroup = false;
    this.setChecked = [];
  }

  public setSendInviteFlag() {
    this.sendInviteFlag = !!(this.successfullyAddedMembers && this.successfullyAddedMembers.length > 0);
  }

  public staffAlreadyExist(id: any) {
    return this.memberList.map(member => { return member.userId; }).indexOf(id);
  }

  public uploadBLockSlotFile(event: any, popupObj: any) {
    const file = event.target.files[0];
    this.popupTitle = '';
    const that = this;
    const reqObj: any = { 'vendorId': this.vendor._id, 'facilityData': [] }

    if (this.vendor['role'] === CONSTANT_VALUES.SUPER_ADMIN) {
      if (this.vendor.subVendors.length > 0) {
        const subVendor = this.vendor.subVendors[0];
        reqObj.vendorId = subVendor._id;
      }
    } else if (this.vendor['role'] === CONSTANT_VALUES.ROLE_STAFF) {
      reqObj.vendorId = this.vendor.vendorId;
    } else {
      reqObj.vendorId = this.vendor._id;
    }

    if (file.name.indexOf('.csv') !== -1) {
      this.blockSlots.readBlockSlotFile(event).then((result: any) => {
        if (result.blockingList.length > 0) {
          reqObj.facilityData = that.blockSlots.calculateBlockSlots(result.blockingList, this.vendor._id);
          if (reqObj.facilityData.length > 0) {
            this.loaderEvent.fire(false);
            that.appService.blockDates(reqObj).then((result1: any) => {
              this.loaderEvent.fire(true);
              that.popUpMessage = result1.message;
              if (result1.status == 'SUCCESS') { this.popupTitle = 'Confirmation'; }
              popupObj.showChildModal();
            });
          }
        } else {
          this.popupTitle = '';
          that.popUpMessage = 'Does not have proper data to block slots';
          popupObj.showChildModal();
        }
      });
    } else {
      this.popUpMessage = CONSTANT_MESSAGES.FILE_NOT_SUPPORT;
      popupObj.showChildModal();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/member/staff-list/staff-list.component.ts